import React, { useEffect, useState } from 'react';
import { FaMapMarkerAlt, FaSyncAlt, FaTruck } from 'react-icons/fa';
import { useParams, useNavigate } from 'react-router-dom';
import BottomNav from '../../components/BottomNav';
import HeaderWithBack from '../../components/HeaderWithBack';
import AddressModal from '../../components/modal/Address';
import PharmacyModal from '../../components/modal/Pharmacy';
import DeliveryModal from '../../components/modal/Delivery';
import axios from '../../api/axios';

const EprescriptionOrder: React.FC = () => {
const navigate = useNavigate();
const { prescriptionId } = useParams<{ prescriptionId: string }>();

  // Ambil data user dari sessionStorage
  const storedData = sessionStorage.getItem('userData');
  
  // State utama
  const userData = storedData ? JSON.parse(storedData) : null;

  // Pastikan token tersedia
  const token = userData ? userData.token : null;

  // Alamat dan Penerima
  const [selectedAddress, setSelectedAddress] = useState(userData?.person?.address?.[userData.person.address.length - 1]?.text || '');
  const [recipient, setRecipient] = useState(userData?.person?.name || '');
  const [label, setLabel] = useState('rumah');

  const [phone, setPhone] = useState(
    userData?.phone_code && userData?.phone ? userData.phone_code + userData.phone : ''
  );

  const [isLoading, setIsLoading] = useState(false);

  const [lat, setLat] = useState<number | null | undefined>(userData?.person?.address?.[userData.person.address.length - 1]?.lat || '');
  const [lng, setLng] = useState<number | null | undefined>(userData?.person?.address?.[userData.person.address.length - 1]?.lng || '');

  // Apotek dan Pengiriman
  const [selectedPharmacyName, setSelectedPharmacyName] = useState<string | null>(null);
  const [selectedPharmacyId, setSelectedPharmacyId] = useState<string | null>(null);
  const [additionalAddress, setAdditionalAddress] = useState('');
  // Opsi pengiriman
  const [deliveryOption, setDeliveryOption] = useState<string | null>(null);
  const [deliveryFee, setDeliveryFee] = useState<number>(0);
  const [serviceFee, setServiceFee] = useState<number>(0);

  // Options metode pembayaran
  const [paymentMethod, setPaymentMethod] = useState<[] | null>(null);
  const [selectedPaymentMethodID, setSelectedPaymentMethodID] = useState<string | null>(null);
  const [selectedPaymentSubID, setSelectedPaymentSubID] = useState<string | null>(null);

  // Modal state
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [isPharmacyModalOpen, setPharmacyModalOpen] = useState(false);
  const [isDeliveryModalOpen, setDeliveryModalOpen] = useState(false);


  // Data resep
  const [prescriptionData, setPrescriptionData] = useState<any>(null);

  // Ketika memilih apotek
  const handlePharmacySelect = (outlet: { outlet_id: string; outlet: string }) => {
    setSelectedPharmacyName(outlet.outlet);
    setSelectedPharmacyId(outlet.outlet_id);
    setDeliveryModalOpen(true);
  };

  const price = deliveryFee+serviceFee

  const isOrderValid = [
    prescriptionId,
    selectedPaymentSubID,
    selectedPharmacyId,
    selectedPharmacyName,
    deliveryOption,
    deliveryFee,
    additionalAddress,
    userData?.person?.address[0]?.id,
  ].every((val) => {
    if (typeof val === 'string') return val.trim() !== '';
    return val !== null && val !== undefined;
  });

  const handleOrderPrescription = async () => {
    try {
      if (!token) {
        alert('Token tidak ditemukan. Silakan login ulang.');
        return;
      }

      setIsLoading(true); // Start loading

      const payload = {
        prescription_id: Number(prescriptionId),
        payment_method_id: selectedPaymentSubID,
        outlet_id: Number(selectedPharmacyId),
        outlet: selectedPharmacyName,
        shipping_method: deliveryOption?.split(' ')[0],
        shipping_cost: deliveryFee,
        address_id: userData?.person?.address[0]?.addressable_id,
        address_detail: additionalAddress,
      };

      const response = await axios.post('prescriptions/order', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data;
      if (data.statusCode === '00' && data.paymentUrl) {
        // ✅ Redirect otomatis ke paymentUrl
        window.location.href = data.paymentUrl;
      } 

      console.log('Order berhasil:', response.data);
      // Navigasi atau feedback
    } catch (error: any) {
      console.error('Gagal membuat order:', error?.response?.data || error.message);
    } finally {
      setIsLoading(false); // Stop loading
    }
  };



  useEffect(() => {
    const fetchDataResep = async () => {
      try {
        const response = await axios.get(`prescriptions/${prescriptionId}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          }
        });

        const data = response.data.data;
        console.log(data, "data");
        setPrescriptionData(data);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    
    fetchDataResep(); // Selalu fetch saat Home dirender
  }, [token, prescriptionId]);

  useEffect(() => {
      const fetchMetodePembayaran = async () => {
        try {
          const response = await axios.get('payment?configuration=category_payment_live_consultation', {
            headers: {
              Authorization: `Bearer ${token}`,
            }
          });
          const data = response.data.data;
          setPaymentMethod(data);
        } catch (error) {
          console.error('Error fetching payment methods:', error);
        }
      };
      
      fetchMetodePembayaran();
    }
  , [token]);

  useEffect(() => {
    setSelectedPharmacyName(null);
    setSelectedPharmacyId(null);
    setDeliveryFee(0);
    setDeliveryOption(null);
    
  },[selectedAddress])

  return (
    <div className="min-h-screen bg-white pb-20">
      <HeaderWithBack title="E-Prescription" />

      <div className="p-4 space-y-4">
        {/* Penerima */}
        <div>
          <p className="font-semibold text-teal-700">📍 Penerima</p>
          <input
            type="text"
            className="border rounded p-2 mt-1 text-sm w-full"
            placeholder="Masukkan nama penerima"
            value={recipient}
            onChange={(e) => setRecipient(e.target.value)}
          />
        </div>

        {/* Dikirim ke */}
        <div>
          <p className="font-semibold text-teal-700 flex items-center">
            <FaMapMarkerAlt className="mr-1" /> Dikirim Ke
            <span
              className="ml-auto text-sm text-teal-500 flex items-center cursor-pointer"
              onClick={() => setShowAddressModal(true)}
            >
              <FaSyncAlt className="mr-1" /> Ubah Alamat
            </span>
          </p>
          <label className="text-xs text-gray-500 capitalize">{label}</label>
          <p className="text-sm mt-1">{selectedAddress}</p>
          <textarea
            className="border rounded w-full mt-2 p-2 text-sm"
            placeholder="Tambahkan info seperti No Rumah, Blok, RT/RW, lantai, atau patokan lokasi"
            rows={2}
            value={additionalAddress}
            onChange={(e) => setAdditionalAddress(e.target.value)}
            required
          />
        </div>

        {/* Modal Address */}
        <AddressModal
          isOpen={showAddressModal}
          onClose={() => setShowAddressModal(false)}
          onSave={(alamatBaru, labelBaru, newLat, newLng) => {
            setSelectedAddress(alamatBaru);
            setLabel(labelBaru);
            setLat(newLat);
            setLng(newLng);
            setShowAddressModal(false);
          }}
          data={{ alamat: selectedAddress, label, lat, lng }}
        />

        {/* Rincian Pemesanan */}
        <div>
          <p className="font-semibold text-teal-700 flex items-center">
            Rincian Pemesanan
            <span
              className="ml-auto text-sm text-teal-500 flex items-center cursor-pointer"
              onClick={() => setPharmacyModalOpen(true)}
            >
              <FaSyncAlt className="mr-1" /> Ganti Apotek
            </span>
          </p>
          <div className="border rounded p-2 mt-2 text-sm">
            <p className="text-gray-500">{selectedPharmacyName || 'Pilih Apotek'}</p>
            
             {prescriptionData?.items?.map((item: any, index: number) => (
              <div
                key={index}
                className="border px-3 py-2 rounded-md text-sm bg-gray-50 mb-2"
              >
                {item?.drug_name} x {item?.qty} {item?.unit} ({item?.frequency_dd} x {item?.frequency})
              </div>
            ))}
            {/* <p className="mt-1">Asmef LAND kapl 500 mg (Tablet) x 10</p> */}
            <div className="flex justify-between text-sm text-gray-600 mt-2">
              <span>Delivery Fee</span>
              <span>Rp. {price.toLocaleString('id-ID')}</span>
            </div>
          </div>
        </div>

        {/* Modal Pharmacy */}
       <PharmacyModal
          isOpen={isPharmacyModalOpen}
          onClose={() => setPharmacyModalOpen(false)}
          onPharmacySelect={handlePharmacySelect}
          onSave={(alamatBaru: string) => setSelectedAddress(alamatBaru)} // ✅ tambahkan ini
          alamatBaru={selectedAddress}
          prescription_id={Number(prescriptionId)}
        />

        {/* Opsi Pengiriman */}
        <div>
          <p className="font-semibold text-teal-700 flex items-center">
            <FaTruck className="mr-1" /> Opsi Pengiriman
          </p>
          <div
            className="border rounded p-2 mt-1 text-sm cursor-pointer"
            onClick={() => setDeliveryModalOpen(true)}
          >
            {deliveryOption ? (
              <div className="flex justify-between items-start text-sm text-gray-600 mt-2">
                <div className="w-2/3 pr-2">
                  <span className="block font-medium">{deliveryOption}</span>
                </div>
                <div className="text-right whitespace-nowrap">
                  <span>Rp. {price.toLocaleString('id-ID')}</span>
                </div>
              </div>
            ) : (
              <p className="text-gray-500">Pilih Metode Pengiriman</p>
            )}
          </div>
        </div>

        {/* Metode Pembayaran */}
        <div className="border rounded p-2 text-sm">
          <p className="font-semibold text-teal-700">Metode Pembayaran</p>
          <div className="mt-2">
            {paymentMethod && paymentMethod.length > 0 ? (
              paymentMethod.map((method: any) => (
                <div key={method.id}>
                  <div
                    className="flex items-center justify-between p-2 border-b last:border-b-0 cursor-pointer"
                    onClick={() => setSelectedPaymentMethodID(method.id)}
                  >
                    <span>{method.name}</span>
                    {selectedPaymentMethodID === method.id && (
                      <span className="text-teal-600 font-semibold">Dipilih</span>
                    )}
                  </div>

                  {/* Tampilkan sub-metode jika dipilih */}
                  {selectedPaymentMethodID === method.id && method.method && (
                    <div className="pl-4 mt-2 space-y-2">
                      {method.method.map((sub: any) => (
                        <div
                          key={sub.id}
                          className="flex items-center gap-2 p-1 border rounded cursor-pointer hover:bg-gray-50"
                          onClick={() => setSelectedPaymentSubID(sub.id)}
                        >
                          <img
                            src={sub.image_url}
                            alt={sub.name}
                            className="w-6 h-6 object-contain"
                          />
                          <span>{sub.name}</span>
                          {selectedPaymentSubID === sub.id && (
                            <span className="ml-auto text-teal-600 font-semibold">
                              ✓
                            </span>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))
            ) : (
              <p className="text-gray-500">Memuat metode pembayaran...</p>
            )}
          </div>
        </div>


        {/* Total Pembayaran */}
        <div className="border rounded p-2 text-sm flex justify-between items-center">
          <p className="font-semibold">Total Pembayaran</p>
          <p className="font-semibold text-teal-600">
            Rp {price.toLocaleString('id-ID')}
          </p>
        </div>

        <button
          className={`w-full py-3 rounded mt-4 font-semibold flex items-center justify-center transition ${
            isOrderValid && !isLoading
              ? 'bg-gray-500 text-white'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
          onClick={handleOrderPrescription}
          disabled={!isOrderValid || isLoading}
        >
          {isLoading ? (
            <>
              <svg
                className="animate-spin h-5 w-5 mr-2 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                ></path>
              </svg>
              Loading...
            </>
          ) : (
            'ORDER'
          )}
        </button>

        {/* Modal Delivery */}
        <DeliveryModal
          isOpen={isDeliveryModalOpen}
          onClose={() => setDeliveryModalOpen(false)}
          pharmacyName={selectedPharmacyName}
          pharmacyId={selectedPharmacyId}
          prescriptionId={Number(prescriptionId)}
          onSave={(option, fee, service) => {
            setDeliveryOption(option);
            setDeliveryFee(fee);
            setServiceFee(service);
            setDeliveryModalOpen(false);
          }}
        />
      </div>

      <BottomNav />
    </div>
  );
};

export default EprescriptionOrder;
